import { render, staticRenderFns } from "./companyHp.vue?vue&type=template&id=1384ade1&scoped=true"
import script from "./companyHp.vue?vue&type=script&lang=js"
export * from "./companyHp.vue?vue&type=script&lang=js"
import style0 from "./companyHp.vue?vue&type=style&index=0&id=1384ade1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1384ade1",
  null
  
)

export default component.exports